<div class="modal-header panel-heading" id="ConfirmationModal">
  <div class="darkNavy-fc title1">{{title | translate}}</div>
</div>
<div class="modal-body">
  <div>
      <span *ngIf="warning == null || warning == ''" [innerHTML] = "message"></span>
      <span *ngIf="warning != null && warning != ''">{{warning | translate}}</span>
  </div>
</div>
<div class="modal-footer" [hidden]="autoClose == true">
  <button type="button" class="greyBtn" *ngIf="cancelString != undefined" (click)="cancel()" >{{cancelString | translate}}</button>
  <button type="button" class="orangeBtn" *ngIf="showYesButton" [ngStyle]="{'background-color': primaryColor}" [disabled]="warning != null && warning != ''" (click)="confirmed()">{{yes | translate}}</button> 
</div>
